import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';

const OrderConfirmationPage = () => {
  const { orderId } = useParams();

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-deepDark flex flex-col items-center justify-center py-20 px-4"
    >
      <div className="max-w-2xl w-full">
        <motion.div 
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="bg-surfaceDark border border-gold/30 p-12 md:p-20 relative overflow-hidden text-center shadow-2xl"
        >
          {/* Decorative Corner Elements */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t border-l border-gold/50"></div>
          <div className="absolute top-0 right-0 w-16 h-16 border-t border-r border-gold/50"></div>
          <div className="absolute bottom-0 left-0 w-16 h-16 border-b border-l border-gold/50"></div>
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b border-r border-gold/50"></div>

          <p className="text-gold text-xs tracking-widest uppercase mb-6 font-bold flex justify-center items-center gap-2">
            <span className="w-8 h-[1px] bg-gold"></span> Transaction Successful <span className="w-8 h-[1px] bg-gold"></span>
          </p>

          <h1 className="text-4xl md:text-5xl font-serif text-white mb-8 tracking-wide leading-tight">
            Welcome to the <br /> LuxeJewels Family
          </h1>
          
          <p className="text-textMuted text-sm font-light leading-relaxed mb-10 max-w-lg mx-auto">
            Your exquisite selection is now being prepared in our vaults. You will receive a bespoke confirmation via email shortly.
          </p>

          <div className="bg-deepDark border border-white/5 py-6 px-4 mb-12">
            <p className="text-[10px] tracking-widest uppercase text-textMuted mb-2">Acquisition Reference</p>
            <p className="text-white font-serif tracking-widest text-lg md:text-xl">{orderId}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link 
              to={`/order/${orderId}`} 
              className="bg-gold text-deepDark px-8 py-4 text-xs font-bold tracking-widest uppercase hover:bg-white transition-colors duration-300"
            >
              Track Deliverable
            </Link>
            <Link 
              to="/products" 
              className="bg-transparent border border-white/30 text-white px-8 py-4 text-xs font-bold tracking-widest uppercase hover:border-gold hover:text-gold transition-colors duration-300"
            >
              Return to Catalog
            </Link>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default OrderConfirmationPage;
